import { useEffect, useRef } from "react";

export function useDebouncedSearch(search: string, onCommit: (value: string) => void) {
	const lastCommitted = useRef(search.trim());

	useEffect(() => {
		const next = search.trim();

		if (next === lastCommitted.current) {
			return;
		}

		const id = setTimeout(() => {
			lastCommitted.current = next;
			onCommit(next);
		}, 300);

		return () => clearTimeout(id);
	}, [search, onCommit]);
}
